import firebase from 'firebase'
import firestore from 'firebase/firestore'

var firebaseConfig = {
    apiKey: "AIzaSyBDrNeSvIZPhorJ2iyMepnjQ64zuZDHax0",
    authDomain: "udemy-ninja-chat-da5bd.firebaseapp.com",
    databaseURL: "https://udemy-ninja-chat-da5bd.firebaseio.com",
    projectId: "udemy-ninja-chat-da5bd",
    storageBucket: "udemy-ninja-chat-da5bd.appspot.com",
    messagingSenderId: "506222820000",
    appId: "1:506222820000:web:bf9fdf0cb51b242da0e7c5"
};
// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);

export default firebaseApp.firestore()


// WEBPACK FOOTER //
// ./src/firebase/init.js